module.exports = __webpack_public_path__ + "fonts/VetoSans-MediumItalic.b879e836.eot";